import { render, staticRenderFns } from "./ApproveItem.vue?vue&type=template&id=0a091ba8&scoped=true&"
import script from "./ApproveItem.vue?vue&type=script&lang=js&"
export * from "./ApproveItem.vue?vue&type=script&lang=js&"
import style0 from "./ApproveItem.vue?vue&type=style&index=0&id=0a091ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a091ba8",
  null
  
)

export default component.exports